import {
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  ViewEncapsulation,
} from '@angular/core'
import { NavigationStart, Router, RouterOutlet } from '@angular/router'
import { FooterComponent } from './core/footer/footer.component'
import { HeaderComponent } from './core/header/header.component'
import { ModalEngineModule } from '@sp401/modal-engine'
import { LandingPageComponent } from './pages/landing/landing.component'
import { LoadingSpinnerComponent } from './core/loading-spinner/loading-spinner.component'
import { CacheService } from './services/cache.service'
import { ConfigService } from './services/config.service'
import { UtilService } from './services/util.service'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    ModalEngineModule,
    LandingPageComponent,
    LoadingSpinnerComponent,
    CommonModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  
})
export class AppComponent {
  cdr = inject(ChangeDetectorRef)
  fullWidthPages: Array<string> = [
    '/',
    '/login',
    '/login/forgot-password',
    '/login/register',
    '/user-profile',
    '/user-profile/account-preferences',
    '/user-profile/security-preferences',
    '/user-profile/vehicle-preferences',
    '/user-profile/in-vehicle-messages',
    '/user-profile/message-settings',
    '/vehicles/vehicle-health-report',
    '/solutions',
    '/vehicles/vehicle-location',
    '/payment',
    '/products',
    '/products/product-discover',
    '/purchase-history',
    '/faq'
  ]
  whiteHeaderUserMenuPages: Array<string> = ['/solutions','/user-profile','/purchase-history','/user-profile/account-preferences','/user-profile/security-preferences','/user-profile/vehicle-preferences',
  ]
  title = 'FleetServicePortal'
  isFullwidth: boolean = false
  isWhiteHeaderUserMenu: boolean = false
  routerSubscriber: any

  constructor(
    private router: Router,
    private cacheService: CacheService,
    private configService: ConfigService,
    private utilService: UtilService
  ) {
    const backOfficeConfig = this.configService.getBackOfficeConfig()
    this.cacheService.setCacheConfig(backOfficeConfig['CACHE'])
    this.routerSubscriber = router.events.subscribe((event) => {
      this.isFullwidth = this.fullWidthPages.some(
        (path) =>
          this.router.url ===
          `/${this.configService.getSelectedCulture()}${path}` ||
          this.router.url ===
          `/${this.configService.getSelectedCulture()}${path}/`
      )
      this.isWhiteHeaderUserMenu = this.whiteHeaderUserMenuPages.some(
        (path) =>
          this.router.url ===
          `/${this.configService.getSelectedCulture()}${path}` ||
          this.router.url ===
          `/${this.configService.getSelectedCulture()}${path}/`
      );
      if (event instanceof NavigationStart) {
        // scroll to top
        this.utilService.scrollToTop();
      }
      this.cdr.markForCheck()
    })
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.routerSubscriber.unsubscribe()
  }
}
